import { action, computed, makeAutoObservable, observable } from 'mobx';

export class UiStore {
  @observable isVideoUploaded = true;

  @observable isSystemUpdateCompleted?: boolean = undefined;

  @observable isPTUUpdateCompleted?: boolean = undefined;

  constructor() {
    this.isFaqModalVisible = false;
    this.isSettingLineup = false;
    this.sessions = 0;
    makeAutoObservable(this);
  }

  @observable isFaqModalVisible: boolean;

  @observable isSettingLineup: boolean;

  @observable sessions: number;

  @observable sessionEndedModalVisible = false;

  @observable primarySystemEndedModalVisible = false;

  @action setSessionEndedModalVisible = (visible: boolean) => {
    this.sessionEndedModalVisible = visible;
  };
  @action setPrimarySystemEndedModalVisible = (visible: boolean) => {
    this.primarySystemEndedModalVisible = visible;
  };

  @action setSessions = (sessions: number) => {
    this.sessions = sessions;
  };

  @action setIsFaqModalVisible = (visible: boolean) => {
    this.isFaqModalVisible = visible;
  };

  @action setIsSettingLineup = (settingLineup: boolean) => {
    this.isSettingLineup = settingLineup;
  };

  @action setIsVideoUploaded = (value: boolean) => {
    this.isVideoUploaded = value;
  };

  @action setIsSystemUpdateCompleted = (value: boolean | undefined) => {
    this.isSystemUpdateCompleted = value;
  };

  @action setIsPTUUpdateCompleted = (value: boolean | undefined) => {
    this.isPTUUpdateCompleted = value;
  };

  @computed({ keepAlive: true }) get isMoreThanOneSession(): boolean {
    return this.sessions > 1;
  }
}
